import React, {useEffect, useState} from "react";
import axios from "axios";
import {baseUrl} from "../Univ";
function OwnerDashboard() {
    const userId = localStorage.getItem("user_id");
    const [ownerId, setOwnerId] = useState(null);
    const [requirements, setRequirements] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [payments, setPayments] = useState([]);
    const [disputes, setDisputes] = useState([]);
    const [loading, setLoading] = useState(false);
    // ---------------- OWNER PROFILE ----------------
    useEffect(() => {
        if (!userId) return;
        axios.get(
            baseUrl + "landowner-profile/" + userId + "/"
        )
            .then((res) => {
                if (res.data.length > 0) {
                    setOwnerId(
                        res.data[0].id
                    );
                }
            })
            .catch(console.log);
    }, [userId]);
    // ---------------- DASHBOARD DATA ----------------
    useEffect(() => {
        if (!ownerId) return;
        loadDashboard();
    }, [ownerId]);
    const loadDashboard = async () => {
        try {
            setLoading(true);
            // ---------------- REQUIREMENTS ----------------
            const reqRes = await axios.get(
                baseUrl + "landowner-req/" + ownerId + "/"
            );
            const reqData = reqRes.data;
            setRequirements(reqData);
            // ---------------- ASSIGNMENTS ----------------
            let allAssignments = [];
            for (const req of reqData) {
                try {
                    const assRes = await axios.get(
                        baseUrl +
                        "assignment-requirement/" +
                        req.id +
                        "/"
                    );
                    allAssignments = [
                        ...allAssignments,
                        ...assRes.data
                    ];
                } catch (err) {
                    console.log(err);
                }
            }
            setAssignments(allAssignments);
            // ---------------- PAYMENTS ----------------
            let allPayments = [];
            for (const ass of allAssignments) {
                try {
                    const payRes = await axios.get(
                        baseUrl +
                        "payment-assignment/" +
                        ass.id +
                        "/"
                    );
                    allPayments = [
                        ...allPayments,
                        ...payRes.data
                    ];
                } catch (err) {
                    console.log(err);
                }
            }
            setPayments(allPayments);
            // ---------------- DISPUTES ----------------
            let allDisputes = [];
            for (const ass of allAssignments) {
                try {
                    const disRes = await axios.get(
                        baseUrl +
                        "dispute-assignment/" +
                        ass.id +
                        "/"
                    );
                    allDisputes = [
                        ...allDisputes,
                        ...disRes.data
                    ];
                } catch (err) {
                    console.log(err);
                }
            }
            setDisputes(allDisputes);
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };
    // ---------------- CALCULATIONS ----------------
    const activeRequirements =
        requirements.filter(
            r => r.status === 1
        ).length;
    const completedRequirements =
        requirements.filter(
            r => r.status === 0
        ).length;
    const activeAssignments =
        assignments.filter(
            a => a.status === "ACTIVE"
        ).length;
    const completedAssignments =
        assignments.filter(
            a => a.status === "COMPLETED"
        ).length;
    const totalPresentDays =
        assignments.reduce(
            (sum, item) =>
                sum +
                Number(
                    item.total_present_days || 0
                ),
            0
        );
    const totalAmountPaid =
        payments.reduce(
            (sum, item) =>
                sum +
                Number(
                    item.amount || 0
                ),
            0
        );
    const pendingDisputes =
        disputes.filter(
            d => d.status === "OPEN"
        ).length;
    const resolvedDisputes =
        disputes.filter(
            d => d.status === "RESOLVED"
        ).length;
    return (
        <section className="container mt-4">

            <h2 className="mb-4">
                Owner Dashboard
            </h2>

            {loading && (
                <div className="alert alert-info">
                    Loading Dashboard...
                </div>
            )}

            {/* SUMMARY */}

            <div className="row">

                <div className="col-md-3 mb-3">
                    <div className="card bg-primary text-white shadow">
                        <div className="card-body text-center">
                            <h5>
                                Total Requirements
                            </h5>
                            <h2>
                                {requirements.length}
                            </h2>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 mb-3">
                    <div className="card bg-success text-white shadow">
                        <div className="card-body text-center">
                            <h5>
                                Active Requirements
                            </h5>
                            <h2>
                                {activeRequirements}
                            </h2>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 mb-3">
                    <div className="card bg-secondary text-white shadow">
                        <div className="card-body text-center">
                            <h5>
                                Completed Requirements
                            </h5>
                            <h2>
                                {completedRequirements}
                            </h2>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 mb-3">
                    <div className="card bg-warning text-dark shadow">
                        <div className="card-body text-center">
                            <h5>
                                Assignments
                            </h5>
                            <h2>
                                {assignments.length}
                            </h2>
                        </div>
                    </div>
                </div>

            </div>

            {/* SECOND ROW */}

            <div className="row">

                <div className="col-md-3 mb-3">
                    <div className="card bg-info text-white shadow">
                        <div className="card-body text-center">
                            <h5>
                                Active Workers
                            </h5>
                            <h2>
                                {activeAssignments}
                            </h2>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 mb-3">
                    <div className="card bg-dark text-white shadow">
                        <div className="card-body text-center">
                            <h5>
                                Completed Works
                            </h5>
                            <h2>
                                {completedAssignments}
                            </h2>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 mb-3">
                    <div className="card bg-success text-white shadow">
                        <div className="card-body text-center">
                            <h5>
                                Attendance Days
                            </h5>
                            <h2>
                                {totalPresentDays}
                            </h2>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 mb-3">
                    <div className="card bg-danger text-white shadow">
                        <div className="card-body text-center">
                            <h5>
                                Open Disputes
                            </h5>
                            <h2>
                                {pendingDisputes}
                            </h2>
                        </div>
                    </div>
                </div>

            </div>

            {/* THIRD ROW */}

            <div className="row">

                <div className="col-md-6 mb-3">
                    <div className="card shadow">
                        <div className="card-body text-center">

                            <h4>
                                Total Payments
                            </h4>

                            <h1>
                                ₹
                                {Number(
                                    totalAmountPaid
                                ).toLocaleString()}
                            </h1>

                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="card shadow">
                        <div className="card-body text-center">

                            <h4>
                                Resolved Disputes
                            </h4>

                            <h1>
                                {resolvedDisputes}
                            </h1>

                        </div>
                    </div>
                </div>

            </div>

            {/* RECENT REQUIREMENTS */}

            <div className="card mt-4 shadow">

                <div className="card-header">
                    Recent Requirements
                </div>

                <div className="card-body">

                    <div className="table-responsive">

                        <table className="erp-table-modern">

                            <thead>

                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th>ID</th>
                                <th>Crop</th>
                                <th>Location</th>
                                <th>Budget</th>
                                <th>Status</th>
                            </tr>

                            </thead>

                            <tbody>

                            {requirements
                                .slice(0, 5)
                                .map((item) => (
                                    <tr key={item.id}>

                                        <td>{item.id}</td>

                                        <td>
                                            {item.crop_type}
                                        </td>

                                        <td>
                                            {item.location}
                                        </td>

                                        <td>
                                            ₹{item.budget}
                                        </td>

                                        <td>

                                            {item.status === 1 ? (
                                                <span className="badge bg-success">
                          Active
                        </span>
                                            ) : (
                                                <span className="badge bg-secondary">
                          Completed
                        </span>
                                            )}

                                        </td>

                                    </tr>
                                ))}

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </section>
    );
}
export default OwnerDashboard;